import { Injectable } from "@angular/core";
import { CognitoUserPool } from "amazon-cognito-identity-js";
import { environment } from "../../../environments/environment";

export interface LoginCognitoCallback {
  cognitoCallback(message: string, result: any): void;

  handleMFAStep(
    challengeName: string[],
    callback: (err: any, res: any) => any
  ): void;
}

export interface LoggedInCallback {
  isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface Callback {
  callback(): void;

  callbackWithParam(result: any): void;
}

export interface CallMeCallback {
  isSuccess(status: boolean): void;
}

@Injectable()
export class CognitoUtil {
  constructor() { }
  public static _REGION = environment.region;

  public static _USER_POOL_ID = environment.userPoolId;
  public static _CLIENT_ID = environment.clientId;

  public static _POOL_DATA: any = {
    UserPoolId: CognitoUtil._USER_POOL_ID,
    ClientId: CognitoUtil._CLIENT_ID
  };

  getUserPool() {
    return new CognitoUserPool(CognitoUtil._POOL_DATA);
  }

  getCurrentUser() {
    return this.getUserPool().getCurrentUser();
  }

  refresh(callback: any): void {
    let user = this.getCurrentUser();
    user!.getSession(function (err: any, session: any) {
      if (err) {
      } else {
        user!.refreshSession(session.getRefreshToken(), callback);
      }
    });
  }
}
